/**
 * @generated SignedSource<<2edbe4b064e2604d45f46695eee0ee33>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useActivityCriteria_query$data = {
  readonly currentUser: {
    readonly activityCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly activityId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useActivityCriteria_query";
};
export type useActivityCriteria_query$key = {
  readonly " $data"?: useActivityCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useActivityCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useActivityCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "ActivityCriterionConnection",
          "kind": "LinkedField",
          "name": "activityCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ActivityCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "activityCriteria(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3493a004c8c539dd9a4347ee66d77e33";

export default node;
